import React from 'react';
import { FormControl } from "react-bootstrap";

const Row = ({ country, factors, onChange }) => {
    const td = [];
    
    for(let i = 0; i < 24; i++) {
        td.push(<td style={{ padding: '0'}}><FormControl type="number" step={0.01} min={0} max={9} name={`${country}_${i}`} value={factors[i]} onChange={onChange} style={{ minWidth: '50px', padding: '3px 5px', border: '0', borderRadius: '0',  }}/></td>)
    }
    
    return (
      <tr>
          <td>{country}</td>
          {td}
      </tr>
    )
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkCountryHourFactor/components/Table/components/Row/index.js